import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Item from './Item';
const Wrapper = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0;
  overflow-y: auto;
`;
/**
 * List component that renders a list of items.
 * @param props - The component props.
 * @param props.active - The active item id.
 * @param props.className - The component class name.
 * @param props.items - The list of items to be displayed.
 * @returns The rendered list component.
 */
const List = ({ items, active, className }) => (_jsx(Wrapper, { className: className, children: items.map(({ id, title, onClick }) => (_jsx(Item, { onClick: onClick, active: id === active, text: title }, id))) }));
export default List;
